import styled from 'styled-components'
import { ArrowDropDown } from '@material-ui/icons'
import { StyledH2, theme, colors, StyledSpan } from '../../theme/Global'

export const StyledClearButton = styled.button`
  background-color: ${colors.white};
  border: none;
  cursor: pointer;
  font-family: "Open Sans";

  & {
    :focus {
      outline: none;
    }
  }
`

export const StyledPlanogramLinks = styled(StyledClearButton)`
  color: ${theme.colors.blueText};
  font-size: 15px;
  font-weight: 600;
`

export const StyledCountryButton = styled(StyledClearButton)`
  color: ${theme.colors.text};
  font-size: 24px;
  font-weight: 600;
  margin-left: 55px;
`

export const StyledDropDownIcon = styled(ArrowDropDown)`
  color: ${colors.govDocsBlue};
  margin-bottom: -15px;
  font-size: 48px;
`

export const StyledCountrySpan = styled(StyledSpan)`
  font-size: 24px;
  font-weight: 600;
  margin-left: 100px;
`

export const StyledDivision = styled.span`
  border-right: 1px solid ${theme.colors.blueText};
`

export const StatesAndProvincesText = styled(StyledH2)`
  color: ${theme.colors.redText};
`

export const StyledSummaryDiv = styled.div`
  & p.editor-paragraph {
    margin: 0;
    position: relative;
  }
  & li.editor-nested-listitem {
    list-style-type: none;
  }
  & ol.editor-list-ol2 {  
    list-style-type: upper-alpha;
  }
  & ol.editor-list-ol3 { 
    list-style-type: lower-alpha;
  }
  & ol.editor-list-ol4 {
    list-style-type: upper-roman;
  }
  & ol.editor-list-ol5 {
    list-style-type: lower-roman;
  }
  & h1.editor-heading-h1 {
    font-size: 24px;
    color: rgb(5, 5, 5);
    font-weight: 400;
    margin: 0;
    margin-bottom: 12px;
    padding: 0;
  }
  & h2.editor-heading-h2 {
    font-size: 15px;
    color: rgb(101, 103, 107);
    font-weight: 700;
    margin: 0;
    margin-top: 10px;
    padding: 0;
    text-transform: uppercase;
  }
  & blockquote.editor-quote {
    margin: 0;
    margin-left: 20px;
    font-size: 15px;
    color: rgb(101, 103, 107);
    border-left-color: rgb(206, 208, 212);
    border-left-width: 4px;
    border-left-style: solid;
    padding-left: 16px;
  }
`
